import {
  GET_RELATED_COMPANIES_AFFIDAVIT,
  GET_RELATED_COMPANIES_AFFIDAVIT_ERROR,
  GET_RELATED_COMPANIES_AFFIDAVIT_SUCCESS
} from './RelatedCompanySection.actions'

const RelatedCompanySectionState = {
  error: null,
  hasAffidavit: false,
  isForcedAffidavit: false,
  loading: true,
  relatedCompanies: []
}

/**
 * The RelatedCompanySection grid section's reducer.
 */
const RelatedCompanySectionReducer = (state = RelatedCompanySectionState, { payload, type }) => {
  switch (type) {
    case GET_RELATED_COMPANIES_AFFIDAVIT: {
      return {
        ...state,
        loading: true
      }
    }
    case GET_RELATED_COMPANIES_AFFIDAVIT_ERROR: {
      return {
        ...state,
        error: payload.error,
        loading: false
      }
    }
    case GET_RELATED_COMPANIES_AFFIDAVIT_SUCCESS: {
      return {
        ...state,
        hasAffidavit: payload.hasAffidavit,
        isForcedAffidavit: payload.isForcedAffidavit,
        loading: false,
        relatedCompanies: payload.relatedCompanies
      }
    }
    default: {
      return state
    }
  }
}

export default RelatedCompanySectionReducer
